var map = {
	"./CameraReticle.svg": "15b9",
	"./american-bittern.jpg": "9cb3",
	"./american-coot.jpg": "13d2c",
	"./american-kestrel.jpg": "4571",
	"./american-robin.jpg": "0c9a",
	"./belted-kingfisher.jpg": "e932",
	"./canada-goose.jpg": "1f1a",
	"./common-loon.jpg": "27b4",
	"./cube/nx.png": "b0b1",
	"./cube/ny.png": "53d6",
	"./cube/nz.png": "abb1",
	"./cube/px.png": "8e76",
	"./cube/py.png": "0914",
	"./cube/pz.png": "9c2d",
	"./eastern-wood-pewee.jpg": "dbb7",
	"./mourning-dove.jpg": "0922",
	"./osprey.jpg": "7dee",
	"./pied-billed-grebe.jpg": "fef7",
	"./placeholder.png": "59e0",
	"./purple-finch.jpg": "b130",
	"./red-tailed-hawk.jpg": "a6f3",
	"./red-winged-blackbird.jpg": "9ac5",
	"./ring-billed-gull.jpg": "3cbc",
	"./song-sparrow.jpg": "c8f8",
	"./swainsons-thrush.jpg": "7707",
	"./warbling-vireo.jpg": "5e97",
	"./western-wood-pewee.jpg": "d93a",
	"./wood-duck.jpg": "13c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";